import styled, { css } from "styled-components";

interface CategoryWrapperProps {
	isExpand?: boolean;
	isFixed?: boolean;
	scrollTop?: number;
	canFixed?: boolean;
}
export const CategoryWrapper = styled.section.withConfig({
	shouldForwardProp: (prop) => !["canFixed", "scrollTop", "isFixed", "isExpand"].includes(prop),
})<CategoryWrapperProps>`
	min-height: 60px;
	overflow: hidden;
	margin: 0 auto 10px;
	${(props: CategoryWrapperProps) => {
		if (props.isExpand) {
			return css`
				height: fit-content;
			`;
		}
		return css``;
	}}
`;
export const CategoryHolderWrapper = styled.section`
	min-height: 60px;
	overflow: hidden;
	position: relative;
	margin: 0 auto 10px;
`;
export const CategoryFloatWrapper = styled.section.withConfig({
	shouldForwardProp: (prop) => !["canFixed", "scrollTop", "isFixed", "isExpand"].includes(prop),
})<CategoryWrapperProps>`
	overflow: hidden;
	height: fit-content;
	visibility: hidden;
	left: 0;
	z-index: -1;
	visibility: hidden;
	opacity: 0;
	width: 100vw;
	transform: translate(0, -60px);
	transition: all 300ms;

	${(props: CategoryWrapperProps) =>
		css`
			top: ${props.scrollTop}px;
		`}

	${(props: CategoryWrapperProps) => {
		if (props.isFixed) {
			return css`
				position: fixed;
				min-height: 60px;
				z-index: 2;
				visibility: visible;
				opacity: 1;
				transform: translate(0, 0);
			`;
		}
		return css``;
	}}
`;
interface CategoryBoxProps {
	width?: number | string;
	hasExpand?: boolean;
	expanded?: boolean;
}
export const CategoryBox = styled.ul.withConfig({
	shouldForwardProp: (prop) => !["expanded", "hasExpand", "width"].includes(prop),
})<CategoryBoxProps>`
	list-style: none;
	overflow: hidden;
	margin: 0 auto;
	padding: 0 0 0 6px;
	box-sizing: border-box;
	position: relative;
	${(props: CategoryBoxProps) => {
		if (typeof props.width === "number") {
			return css`
				width: ${props.width}px;
			`;
		}
		return css`
			width: ${props.width || "1200px"};
		`;
	}}
	${(props: CategoryBoxProps) => {
		if (props.hasExpand) {
			return css`
				padding-right: 60px;
			`;
		}
		return css``;
	}}

	${(props: CategoryBoxProps) => {
		if (props.expanded) {
			return css`
				height: auto;
			`;
		}
		return css`
			height: 60px;
		`;
	}}

	& > li {
		height: 44px;
		padding: 5px 10px;
		color: #333;
		margin: 8px;
		font-size: 14px;
		float: left;
		box-sizing: border-box;
		line-height: 34px;
		cursor: pointer;
		border-radius: 4px;

		html[dir="rtl"] & {
			float: right;
		}
	}
`;
export const ControllerArrow = styled.i`
	height: 30px;
	width: 30px;
	margin: 15px 10px;
	position: absolute;
	right: 0;
	top: 0;
	background-size: 55%;
	background-repeat: no-repeat;
	background-position: center;
	display: block;
	cursor: pointer;
	transition: transform 300ms;
	background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAeCAYAAACBkybCAAAAAXNSR0IArs4c6QAABDFJREFUWAntlktIlFEUx5uHo6XSCyR05yJoJ/iuRJvK1JAyszB7QIFBtAjatHTTpkUQRAVFREQhU4nkq5QSCt9CIIQkmQRpGUao08tR+51wPr65cyf7RsdcdOFy7znn3nPO/57H961Y8X8szxewRdqt1NTUbTabbfPs7Gxbb2/vs0jac0RSeVpa2nn032C6mceSkpJcw8PDTyNlM2JgAHKBaJxTHM8BUCyAmhX+opARAQOQiwA5G8LDLQBaDaDHIeRhsxcdDDVyCW/OzONRdmJi4rqRkZGmec5ZEi9aAyASNiJyGeunLHhwpaen5zQNYtbCnZBH7SElFgQCJD09/RpXgoDg6DTzITKdw6e4d1XuWzAX8uiCwcwBuc5aqVoBhI9ZweuX2u3248hn1DPcOwkgub9gQAsCU1VVZSe1buLICdVJ6ClmeXd3d7XIWG8B6KhESmjzkPuiR/SZ+Vb3YTcAMVxXV3cLg8c0RgXIAT6Skl7GoIP10cn6YZQwVcdTBgYGkisrK2tbW1t1KWnoCbUJK7RlZWWOwcHB2yg9pFH80+FwlHZ1ddVpZL9ZGRkZJdPT0xKxKM2Zu8nJyUc9Hk9QBDVnA1iWweTl5TknJyfvkBoHAzRBkELfWfZRI42qTKWpk+KZmRkP/GhVhp7quLi4w0TIp8r+RFsCMwfkHkD2q0px4Bv8vaTWE1UWigZQAXdqmDHqGfTdB1C5FUB/DYaPoaSEpIbkuzq+klrFpJbl/y4A7SBCtShcpSqFrmEe5IGkBucdahFqL1AjLnkphDogXrpUUThAxBhdrgXdu9l6hVZGidgV+wpfS84bmcLCwujR0dEH3BaDAQNDE6RIES/3IkAQBkHkt6KvAX3xmuv1CQkJpY2NjT80MoP1RzDUSAzFLjldYNyY22B4nIgUEJF2VRYunZmZmeXz+eR/bbWqA3tN1FAJNSRNRjtCgsnOzl45NTVVC5CdmptfUL6LrtWlkS2IRdtOo21LE1mrKsJmc1RU1J729vZvqkxoLRhCLsX4iOmWQ+aBws8Ue35nZ2evmb+Ye5pCCo/Ywlyv0StNppjU/qrKghpAfn5+LA7Xc1AHZAzZ9kgCEQdpCi8Bso3tqNDKcIt/4qfCD4wMNRI3MTHRwKEc9SD0J+Z2XqRPI4sIKysraxM19BRgGzQGnsfHxxdRQ5N+mZFmAHECREIYBISX+EhquYnIK//FpVqpoY3UkPiVpLEpgNz+D6uRZl6vt5TDQUDgjfAyef8CiDhPt3zNkst8J7QycgjAAT/PAIPDa/xM0/re6XTmklr9Jt6Sb7H/hi6WS4a8VY3DM7qeAYZvhnzhh02Hh9jnEpEBE++fbTs6OoZwXABJpH4P9h9cLpfHoP0bWcnP9eRnBcB8zDsAGTfLl8NeutjY2NgRgMQA5G5bW5uu4y0HV//7YLzAL9xVmo0RhVBHAAAAAElFTkSuQmCC");

	&.arrowDown {
		transform: rotate(180deg);
	}
`;
